import audit from './audit'
import quit from './quit'
import initiation from './initiation'
import fee from './fee'
import list from './list'
import common from './common'
import register from './register'
import change from './change'
import stastic from './stastic'

export default {
    audit,
    quit,
    initiation,
    fee,
    list,
    common,
    register,
    change,
    stastic
}



// WEBPACK FOOTER //
// ./src/api/member/index.js